import { useState } from "react";
import { useVersionCheck } from "@/hooks/useVersionCheck";

export function UpdateBanner() {
  const { isStale } = useVersionCheck();
  const [dismissed, setDismissed] = useState(false);

  if (!isStale || dismissed) return null;

  return (
    <div className="fixed left-0 right-0 top-0 z-[9999] flex items-center justify-between bg-primary px-4 py-2 text-primary-foreground shadow-md">
      <span className="text-sm font-medium">
        Nouvelle version disponible, veuillez rafraîchir
      </span>
      <div className="flex items-center gap-2">
        <button
          onClick={() => window.location.reload()}
          className="rounded bg-white px-3 py-1 text-sm font-semibold text-primary transition-colors hover:bg-white/90"
        >
          Rafraîchir
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="px-2 py-1 text-sm opacity-80 transition-opacity hover:opacity-100"
        >
          Plus tard
        </button>
      </div>
    </div>
  );
}
